import Select from "./AddressSelect";
import Postcode from "./AddressPostcode";

export default {
  Select,
  Postcode,
};
